// actions
import actionTypes from "../common/actionTypes";
// constants
import { DATABASE_STATUTES } from "../common/constants";

const statReducer = (state, action) => {
  switch (action.type) {
    // fetch stats
    case actionTypes.FETCH_SHOP_STATS:
    case actionTypes.FETCH_TOTAL_STATS:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
      };
    case actionTypes.FETCH_SHOP_STATS_FAILURE:
    case actionTypes.FETCH_TOTAL_STATS_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };
    case actionTypes.FETCH_TOTAL_STATS_SUCCESS:
      return {
        ...state,
        totalStat: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };
    case actionTypes.FETCH_SHOP_STATS_SUCCESS:
      return {
        ...state,
        shopStat: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };
    default:
      return state;
  }
};

export default statReducer;
